export default __webpack_public_path__ + "static/media/55-56.a78ba4bb.png";